declare global {
  interface Window {
    asklyApi: {
      openChatTab: () => void
    }
  }
}

export const useAsklyChat = () => {
  const {
    public: {
      scripts: {
        askly: { clientKey },
      },
    },
  } = useRuntimeConfig()

  return useScript({
    src: 'https://chat.askly.me/cw/chat/latest.js',
    async: true,
    crossorigin: false,
    // @ts-expect-error no type exists for arbitrary attribute names
    'tw-client-key': clientKey,
    'hide-minimized': true,
  })
}
